(() => {
  function formatMoney(cents, template) {
    const amount = cents / 100;
    const formats = {
      amount: () => amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      amount_no_decimals: () => Math.round(amount).toLocaleString('en-US'),
      amount_with_comma_separator: () => amount.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      amount_no_decimals_with_comma_separator: () => Math.round(amount).toLocaleString('de-DE'),
      amount_with_space_separator: () => amount.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      amount_no_decimals_with_space_separator: () => Math.round(amount).toLocaleString('fr-FR'),
      amount_with_apostrophe_separator: () => amount.toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    };

    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) =>
      formats[key] ? formats[key]() : amount.toLocaleString('ja-JP')
    );
  }

  function updateSubtotal(productInfo) {
    if (!productInfo) return;
    const subtotal = productInfo.querySelector('[data-bs-product-subtotal]');
    if (!subtotal) return;

    const variantId = productInfo.querySelector('product-form input[name="id"]')?.value;
    const quantity = Number(productInfo.querySelector('.quantity__input')?.value);
    // Dawn refreshes the price block when a variant changes, not the subtotal block.
    const unitPrice = Number(productInfo.querySelector('[data-bs-unit-price]')?.dataset.bsUnitPrice ?? subtotal.dataset.unitPrice);
    const awaitingChoice = productInfo.matches('[data-bs-dpas-pending], [data-bs-toli-pending]');
    const canCalculate = variantId && !awaitingChoice && Number.isInteger(quantity) && quantity > 0 && Number.isFinite(unitPrice);

    subtotal.hidden = !canCalculate;
    if (!canCalculate) return;

    subtotal.querySelector('[data-bs-subtotal-value]').textContent = formatMoney(
      unitPrice * quantity,
      subtotal.dataset.moneyFormat
    );
  }

  function init() {
    document.querySelectorAll('product-info').forEach(updateSubtotal);
    document.addEventListener('change', (event) => {
      if (event.target.matches('product-info .quantity__input')) {
        updateSubtotal(event.target.closest('product-info'));
      }
    });
    document.addEventListener('input', (event) => {
      if (event.target.matches('product-info .quantity__input')) {
        updateSubtotal(event.target.closest('product-info'));
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        queueMicrotask(() => {
          document.querySelectorAll('product-info').forEach((productInfo) => {
            if (productInfo.dataset.section === data.sectionId) updateSubtotal(productInfo);
          });
        });
      });
      subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
        document.querySelectorAll('product-info').forEach(updateSubtotal);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
